export default __webpack_public_path__ + "static/media/logo.73ed1988.svg";